import { render, staticRenderFns } from "./year-table.vue?vue&type=template&id=35e8d0fc&"
import script from "./year-table.vue?vue&type=script&lang=js&"
export * from "./year-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "year-table.vue"
export default component.exports